/** @jsx React.DOM */
'use strict';

var React = require('react'),
    Container = require('./Container');

var DustbinSimple = React.createClass({displayName: 'DustbinSimple',
  render:function() {
    return (
      React.createElement("div", null, 
        React.createElement(Container, null), 
        React.createElement("hr", null), 
        React.createElement("p", null, 
          "Drag items on a dropzone. Note that it has different neutral, active (something is being dragged) and hovered states." + ' ' +
          "Dragged item itself has neutral and dragging states."
        )
      )
    );
  }
});

module.exports = DustbinSimple;


/*****************
 ** WEBPACK FOOTER
 ** ./_dustbin-simple/index.js
 ** module id = 146
 ** module chunks = 0
 **/